export const AddOn = () => {
    return (
        <svg aria-hidden="true" viewBox="0 0 48 48" fill="currentColor">
            <path
                fillRule="evenodd"
                d="M38 16.125L24 7.375L10 16.125V31.875L24 40.625L38 31.875V16.125ZM24 29C26.7614 29 29 26.7614 29 24C29 21.2386 26.7614 19 24 19C21.2386 19 19 21.2386 19 24C19 26.7614 21.2386 29 24 29Z"
            />
        </svg>
    );
};
